import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
// import { HttpClientService } from 'src/app/http-client';
// import { Store } from 'store';
// import { User } from 'src/app/models/user.model';
import { map, catchError } from 'rxjs/operators';
import { HttpClientService } from 'src/app/core/http/http-client';
import { Store } from 'src/app/core/store/store';
import { Course } from '../models/course.model';
import { User } from '../models/user.model';
import { environment } from 'src/environments/environment';
// import { SocialLoginervice } from './social-login.service';
// import { SocialLoginervice } from '../auth/shared/services/social-login.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  url = environment.apiBaseUrl;
  constructor(private http: HttpClientService, private store: Store, /* private socialLoginService: SocialLoginervice */) { }

  updateAssesment(body = {}) {
    return this.http.post<{ data: User, result: number, msg: string }>('users/assesment', body).pipe(
      map(res => {
        this.store.set('user', res.data)
        return res;
      }),
      catchError(err => {
        return [err];
      })
    );
  }
  /* startCourse(courseId: string) {
    return this.http.post<{ data: User, result: number, msg: string }>('users/start-course-learning', { "courseId": courseId }).pipe(
      map(res => {
      this.store.set('user', res.data);
        return res;
      }),
      catchError(err => {

        return [err];
      })
    )
  } */

  getRecommendedCourses(project: string = '',isPopular=true, skip: number = 0, limit: number = 100,) {
    return this.http.put<{ data: Course[], result: number, msg: string }>(`courses/recommended?skip=${skip}&limit=${limit}&isPopular=${isPopular}&project=${project}`).pipe(map(res => {
      return res.data;
    }));
  }

  uploadImage(str: string, prefix?: string) {
    return this.http.post<{ data: string }>('/utils/upload-option-image', { base64: str, prefix }).pipe(
      map(res => res.data)
    )
  }

  updateUser(data, userId, organization) {
    return this.http.put<{ data: User, result: number, msg: string }>(`users/${userId}/${organization}`, data).pipe(
      map(res => {
        this.store.set('user', res.data)
        return res;
      }),
      catchError(err => {
        return [err];
      })
    );
  }

  updateUserProfile(data, userId, organization) {
    return this.http.put<{ data: User, result: number, msg: string }>(`users/updateprofile/${userId}/${organization}`, data).pipe(
      map(res => {
        this.store.set('user', res.data)
        return res;
      }),
      catchError(err => {
        return [err];
      })
    );
  }

  subscribe(email, type = 'BLOG') {
    return this.http.post<{ data: User, result: number, msg: string }>('subscribe', { email, type }).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        return [err];
      })
    );
  }

  alreadySubscribed(email, type?: string) {
    return this.http.get<{ data: User, result: number, msg: string }>(`subscribe/is-email-exists?email=${email}&type=${type}`).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        return [err];
      })
    );
  }


  getDailyStreaks(month) {
    return this.http.get<{ data: { _id: string, organization: string, timeSpent: number, userId: string, createdDate: string }[], result: number, msg: string }>(`/daily-streaks?month=${month}`).pipe(map(res => {
      return res.data;
    }));
  }

  courseCompleted(courseId,activationId) {
    return this.http.get<{ data: { contents: any, exercises: any }, result: number, msg: string }>(`/ipj/user-progress/course/complete/${courseId}?activationId=${activationId}`).pipe(map(res => {
      return res.data;
    }));
  }
  saveExercise(data) {
    return this.http.put<{ data: any, result: number, msg: string }>(`ipj/user-progress/save-exercise-and-video-progress`, data).pipe(
      map(res => {
        this.store.set('currentUserCourse', res.data);
        return res;
      }),
      catchError(err => {
        return [err];
      })
    );
  }

  sendEmailVerification() {
    return this.http.get<{ data: any, result: number, msg: string }>(`users/send-verification-email`);
  }

  verifyEmail(uniqueNumber, linkType = 'VERIFY_EMAIL') {
    return this.http.put<{ data: any, result: number, msg: string }>(`utils/verify-email`, { uniqueNumber, linkType }).pipe(
      map(res => {
        // this.socialLoginService.getUser(res.data);
        return res;
      }),
      catchError(err => {
        return [err];
      })
    );
  }

  /**
   * Get banner data
   * @param org organization
   */
  getBannerDatails(org) {
    return this.http.get<{ data: any, result: number, msg: string }>(`banner/${org}`);
  }

  watchVideo(data){
    return this.http.post<{ data: User, result: number, msg: string }>('ipj/user/watch-video', data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  getProgramActivation() {
    let activeProgram=[];
    let activeResponse ={};
    return this.http.get(`ipj/user/activation`).pipe(map(res => {
      if(res){
        res['data'].forEach(element => {
          if(element.isActive){
            activeProgram.push(element);
           activeResponse ={
              data : activeProgram
            }
          }

        });
        activeResponse['msg']= res['msg'];
        activeResponse['result']= res['result'];
        return activeResponse;
      }
    }));
    // return this.http.get(`ipj/user/activation`);
  }

  startCourse(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>('ipj/user-progress/start', data).pipe(
      map(res => {
      this.store.set('currentUserCourse', res.data);
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  startMasterclass(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>('ipj/user-progress/start', data).pipe(
      map(res => {
      this.store.set('currentUserCourse', res.data);
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  generateZoomSignature(data: any) {
    return this.http.post<{ data: any, result: number, msg: string }>('zoom/signature', data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  startExercise(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>(`ipj/user-progress/start`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  startIntegration(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>('ipj/user-progress/start', data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  getActivationInfo(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>(`ipj/user/activation-info`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    )
  }

  getActivationDashboard(data: any) {
    return this.http.post<{ data: User, result: number, msg: string }>(`ipj/user/activation-dashboards`, data).pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        return [err];
      })
    ) 
  }

}
